import type { AppDispatch } from '@core/core/store'
import type { ProjectId } from 'common/types'

import { getValidVelocityElementTypesApi } from '../../api'
import { velocityAllowedTypesSlice } from './velocityAllowedTypesSlice'
const { addVelocityAllowedTypes } = velocityAllowedTypesSlice.actions

export const getVelocityAllowedTypes = (projectId: ProjectId) => async (dispatch: AppDispatch) => {
  try {
    const allowedTypes = await getValidVelocityElementTypesApi()
    dispatch(addVelocityAllowedTypes({ id: projectId, items: allowedTypes }))
  } catch (error) {
    console.error(error)
  }
}
